export const AUTH_PAGE = 'auth/page';
export const AUTH_CODE = 'auth/code';
export const AUTH_PHONE = 'auth/phoneNumber';
export const SHOW_TEXT = 'user-card/showText';
export const SET_USER_DATA = 'set_user_data';
export const LOG_OUT = 'log_out';
